// extracted by mini-css-extract-plugin
export default {"charts":"ReportChart_charts__Z2gVl"};